import { H } from "@ecco/ui/a11y-heading";
import { Box } from "@ecco/ui/box";
import { Text } from "@ecco/ui/text";
import { NextLink } from "@components/ui/next-link/NextLink";

import { styles } from "./error.styles";

type HttpErrorMessageType = {
    errorCode: number;
    headline: string;
    text: string;
    linkToHomeText?: string;
};

export const HttpErrorMessage = ({
    errorCode,
    headline,
    text,
    linkToHomeText,
}: HttpErrorMessageType) => {
    return (
        <Box sx={styles.httpErrorContainer} data-testid="404Container">
            <H size="h1" aria-label={`${headline} ${text} ${errorCode}`}>
                {headline}
            </H>
            <Text
                aria-hidden="true"
                color={"black"}
                fontWeight={"bold"}
                fontSize={["mobileH1", "mobileH1", "tabletH1", "desktopH1"]}
            >
                {text}
            </Text>
            <Text
                aria-hidden="true"
                color={"black"}
                fontWeight={"bold"}
                fontSize={["mobileH1", "mobileH1", "tabletH1", "desktopH1"]}
            >
                {errorCode}
            </Text>
            {linkToHomeText && (
                <p>
                    <NextLink href="/">{linkToHomeText}</NextLink>
                </p>
            )}
        </Box>
    );
};
export default HttpErrorMessage;
